import {
    CLIENT_DETAILS_SUCCESS,
    CLIENT_DETAILS_FAILURE,
    CLIENT_DETAILS_RESET,
    CLIENT_SET_LOADING,
    CLIENT_SET_ERROR,
    CLIENT_CLEAR_ERROR,
    CLIENT_CREATE_REQUEST,
    CLIENT_CREATE_SUCCESS,
    CLIENT_CREATE_FAILURE,
    CLIENT_CREATE_RESET,
    CLIENT_SET_FILTERS,
    CLIENT_CLEAR_FILTERS,
    CLIENT_SET_SELECTED
} from "./ServiceActionType";

/* ============================================================
   CLIENT INTERFACES
============================================================ */

const apiConfig = window as any;

/* ------------------- BASE API URL ------------------- */

const BASE_API_URL =
    apiConfig.BASE_API_URL?.charAt(apiConfig.BASE_API_URL.length - 1) === "/"
        ? apiConfig.BASE_API_URL.substring(0, apiConfig.BASE_API_URL.length - 1)
        : apiConfig.BASE_API_URL;

console.log("Client API URL:", BASE_API_URL);

const BasicAuthentication = apiConfig.BasicAuthentication;

/* ------------------- HEADERS ------------------- */

const postAuthorizedHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(BasicAuthentication
        ? { Authorization: "Basic " + btoa(BasicAuthentication) }
        : {})
};

export interface ClientRecord {
    client_id: number | null;
    client_name: string | null;
    client_phone: string | null;
    client_email: string | null;
    client_status: 'active' | 'inactive' | 'pending' | null;
    quotation: number | null;
    assignment: string | null;
    exact_requirement_notes: string | null;
    assignment_timeline: string | null;
    assignment_status: 'not_started' | 'in_progress' | 'completed' | 'on_hold' | null;
    payment_information: string | null;
    payment_timeline: string | null;
    review: string | null;
    client_address: string | null;
    cources: string | null;
    employee_code: string | null;
    updatedby: string | null;
    created_at: string | null;
    updated_at: string | null;
    caller: string | null;
    counsellor: string | null;
    follow_up: string | null;
    payment_mode: string | null;
    payment_account: string | null;
}

export interface Employee {
    ID?: number;
    EmployeeID?: number;
    employeeCode?: string;
    EmployeeCode?: string;
    employeeName?: string;
    EmployeeName?: string;
    Email?: string;
    email?: string;
    MobileNumber?: string;
    mobileNumber?: string;
    Department?: string;
    department?: string;
    Designation?: string;
    designation?: string;
    EmploymentStatus?: string;
    employmentStatus?: string;
    IsActive?: boolean;
    isActive?: boolean;
}

export interface EmployeeInfo {
    employeeCode: string;
    employeeName: string;
}

export interface ClientApiResponse {
    isSuccess: boolean;
    message: string;
    records: ClientRecord[];
    emplopyelist: Employee[] | null;
    accessedOn: string | null;
}

/* ============================================================
   CREATE/UPDATE/DELETE CLIENT API ACTION (DYNAMIC)
============================================================ */

export const ManageClient = (clientData: any) => async (dispatch: any) => {

    dispatch({ type: CLIENT_SET_LOADING, payload: true });
    dispatch({ type: CLIENT_CREATE_REQUEST });

    try {

        const payload = {
            indicator: clientData.indicator,
            id: clientData.id || 0,
            clientName: clientData.clientName || "",
            clientPhone: clientData.clientPhone || "",
            clientEmail: clientData.clientEmail || "",
            clientStatus: clientData.clientStatus || "pending",
            quotation: clientData.quotation ? clientData.quotation.toString() : "0",
            assignment: clientData.assignment || "",
            exactRequirementNotes: clientData.exactRequirementNotes || "",
            assignmentTimeline: clientData.assignmentTimeline || "",
            assignmentStatus: clientData.assignmentStatus || "not_started",
            paymentInformation: clientData.paymentInformation || "",
            paymentTimeline: clientData.paymentTimeline || "",
            review: clientData.review || "",
            clientAddress: clientData.clientAddress || "",
            cources: clientData.cources || "",
            caller: clientData.caller || "",
            counsellor: clientData.counsellor || "",
            followUp: clientData.followUp || "",
            employeeCode: clientData.employeeCode || "",
            updatedBy: clientData.updatedBy || clientData.changedBy || "",
            createdAt: clientData.createdAt || null,
            updatedAt: clientData.updatedAt || new Date().toISOString(),
            // Payment fields – now sent as camelCase to match Java backend
            paymentMode: clientData.paymentMode || "",
            paymentAccount: clientData.paymentAccount || ""
        };

        console.log("Manage Client Payload:", payload);

        const response = await fetch(`${BASE_API_URL}/ManageClient`, {
            method: "POST",
            headers: postAuthorizedHeaders,
            body: JSON.stringify(payload)
        });

        const data = await response.json();

        console.log("Manage Client Response:", data);

        dispatch({ type: CLIENT_SET_LOADING, payload: false });

        if (data.success) {

            dispatch({
                type: CLIENT_CREATE_SUCCESS,
                payload: data
            });

            if (clientData.employeeCode) {
                dispatch(GetClientDetailsByEmployee(clientData.employeeCode));
            }

            return {
                success: true,
                clientId: data.clientID,
                message: data.message,
                indicator: payload.indicator
            };

        } else {

            dispatch({
                type: CLIENT_CREATE_FAILURE,
                payload: data.message
            });

            return {
                success: false,
                message: data.message
            };
        }

    } catch (error) {

        console.error("ManageClient Error:", error);

        dispatch({ type: CLIENT_SET_LOADING, payload: false });

        dispatch({
            type: CLIENT_CREATE_FAILURE,
            payload: "Client operation failed"
        });

        return { success: false };
    }
};

/* ============================================================
   GET CLIENT DETAILS BY EMPLOYEE CODE
============================================================ */

export const GetClientDetailsByEmployee = (employeeCode: string) => async (dispatch: any) => {

    console.log(`========== ACTION: GetClientDetailsByEmployee ==========`);
    console.log(`Fetching client details for employee code: ${employeeCode}`);

    dispatch({ type: CLIENT_SET_LOADING, payload: true });

    try {
        const params = new URLSearchParams();
        if (employeeCode) {
            params.append('employeeCode', employeeCode);
        }

        const queryString = params.toString();
        const url = `${BASE_API_URL}/ClientDetailsByEmp${queryString ? `?${queryString}` : ''}`;

        console.log("Fetching client details from:", url);

        const response = await fetch(url, {
            method: "GET",
            headers: postAuthorizedHeaders
        });

        console.log("Response status:", response.status);

        const data: ClientApiResponse = await response.json();

        console.log("RAW CLIENT API RESPONSE:", data);
        console.log("isSuccess:", data?.isSuccess);
        console.log("Message:", data?.message);
        console.log("Records:", data?.records);
        console.log("Records length:", data?.records?.length);
        console.log("Employee List (RAW):", data?.emplopyelist);
        console.log("Employee List Type:", typeof data?.emplopyelist);
        console.log("Is Employee List Array:", Array.isArray(data?.emplopyelist));

        // Transform employee list to ensure consistent format
        let transformedEmployeeList: Employee[] = [];

        // ALWAYS transform employee list if it exists, regardless of isSuccess
        if (data?.emplopyelist && Array.isArray(data.emplopyelist)) {
            transformedEmployeeList = data.emplopyelist.map(emp => {
                // Handle different possible field name formats
                const normalizedEmp: any = {};

                // Map employeeCode (handle both camelCase and PascalCase)
                normalizedEmp.employeeCode = emp.employeeCode || emp.EmployeeCode || '';
                normalizedEmp.employeeName = emp.employeeName || emp.EmployeeName || '';
                normalizedEmp.email = emp.email || emp.Email || '';
                normalizedEmp.mobileNumber = emp.mobileNumber || emp.MobileNumber || '';
                normalizedEmp.department = emp.department || emp.Department || '';
                normalizedEmp.designation = emp.designation || emp.Designation || '';
                normalizedEmp.employmentStatus = emp.employmentStatus || emp.EmploymentStatus || '';
                normalizedEmp.isActive = emp.isActive !== undefined ? emp.isActive : emp.IsActive;

                // Keep original data for debugging
                normalizedEmp._original = emp;

                return normalizedEmp;
            });

            console.log("Transformed Employee List:", transformedEmployeeList);
        }

        dispatch({ type: CLIENT_SET_LOADING, payload: false });

        // Handle both success and failure cases, but ALWAYS return employee list
        if (data && data.isSuccess === true && Array.isArray(data.records)) {
            console.log(`✅ API returned success with ${data.records.length} client records`);
            console.log(`📋 Employee list size: ${transformedEmployeeList.length}`);

            dispatch({
                type: CLIENT_DETAILS_SUCCESS,
                payload: {
                    records: data.records,
                    message: data.message,
                    emplopyelist: transformedEmployeeList
                }
            });

            return {
                success: true,
                records: data.records,
                message: data.message,
                emplopyelist: transformedEmployeeList
            };
        } else if (data && data.isSuccess === true) {
            console.log("✅ API returned success but no records found");

            dispatch({
                type: CLIENT_DETAILS_SUCCESS,
                payload: {
                    records: [],
                    message: data.message || "No clients found for this employee",
                    emplopyelist: transformedEmployeeList
                }
            });

            return {
                success: true,
                records: [],
                message: data.message || "No clients found for this employee",
                emplopyelist: transformedEmployeeList
            };
        } // In the failure case of GetClientDetailsByEmployee
        else {
            console.log("❌ API returned error:", data?.message);
            console.log("⚠️ Still returning employee list if available:", transformedEmployeeList);

            const errorMessage = data?.message || "Failed to fetch clients";

            dispatch({
                type: CLIENT_DETAILS_FAILURE,
                payload: errorMessage,
                emplopyelist: transformedEmployeeList  // Add this line
            });

            dispatch({
                type: CLIENT_SET_ERROR,
                payload: {
                    success: false,
                    message: errorMessage,
                    error: data,
                    emplopyelist: transformedEmployeeList  // Add this line
                }
            });

            return {
                success: false,
                records: [],
                message: errorMessage,
                emplopyelist: transformedEmployeeList
            };
        }
    } catch (error) {

        console.error("GetClientDetailsByEmployee Error:", error);

        dispatch({ type: CLIENT_SET_LOADING, payload: false });

        const errorMessage = error instanceof Error ? error.message : "Failed to fetch clients";

        dispatch({
            type: CLIENT_SET_ERROR,
            payload: {
                success: false,
                message: errorMessage,
                error: error
            }
        });

        dispatch({
            type: CLIENT_DETAILS_FAILURE,
            payload: errorMessage
        });

        // Even on network error, return empty employee list
        return {
            success: false,
            records: [],
            message: errorMessage,
            emplopyelist: [],  // Empty array on network error
            error: error
        };
    }
};

/* ============================================================
   RESET CLIENT STATE
============================================================ */

export const ResetClientState = () => ({
    type: CLIENT_CREATE_RESET
});

/* ============================================================
   ADDITIONAL CLIENT ACTIONS
============================================================ */

export const SetSelectedClient = (clientRecord: ClientRecord | null) => ({
    type: CLIENT_SET_SELECTED,
    payload: clientRecord
});

export const ClearClientDetails = () => (dispatch: any) => {
    dispatch({ type: CLIENT_DETAILS_RESET });
};

export const ClearClientError = () => ({
    type: CLIENT_CLEAR_ERROR
});

/* ============================================================
   CLIENT FILTER ACTIONS
============================================================ */

export interface ClientFilterRequest {
    clientStatus?: string;
    assignmentStatus?: string;
    fromDate?: string;
    toDate?: string;
    searchTerm?: string;
}

export const SetClientFilters = (filters: ClientFilterRequest) => ({
    type: CLIENT_SET_FILTERS,
    payload: filters
});

export const ClearClientFilters = () => ({
    type: CLIENT_CLEAR_FILTERS
});